import React, { useState, useEffect } from "react";
import SendEmailMessage from "../../../components/SendEmailMessage";
import EmailPreviewModal from "../../../components/EmailPreviewModal";
import { Button, Box, Flex, useDisclosure } from "@chakra-ui/react";

const API_BASE_URL = "https://qaapirgeneng.digitalfields.co.za/ws1.cfc";

const Communication = ({ recipientID, HrequestID }) => {
  const [communicationHistory, setCommunicationHistory] = useState([]);
  const [selectedEmailBody, setSelectedEmailBody] = useState("");

  const { isOpen, onOpen, onClose } = useDisclosure();

  const HuserID = localStorage.getItem("HuserID");
  const UUID = localStorage.getItem("UUID");

  const fetchCommunicationHistory = async (id) => {
    try {
      let url = `${API_BASE_URL}?method=getCommsPerRecipient&huserID=${HuserID}&uuid=${UUID}&targetUserID=${id}`;

      const response = await fetch(url, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setCommunicationHistory(data);
    } catch (error) {
      console.error("Error fetching communication history", error);
    }
  };

  const fetchEmailBody = async (commslogid) => {
    try {
      let url = `${API_BASE_URL}?method=showEmailBody&huserID=${HuserID}&uuid=${UUID}&commslogID=${commslogid}`;

      const response = await fetch(url, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      setSelectedEmailBody(html);
    } catch (error) {
      console.error("Error email body", error);
    }
  };

  const handlePreviewClick = async (commslogid) => {
    await fetchEmailBody(commslogid);
    onOpen();
  };

  useEffect(() => {
    if (recipientID) {
      fetchCommunicationHistory(recipientID);
    }
  }, [recipientID]);

  return (
    <Box p="4">
      <SendEmailMessage
        recipientID={recipientID}
        HrequestID={HrequestID}
        onMessageSent={() => fetchCommunicationHistory(recipientID)}
      />

      <Box
        className="assessment-list"
        style={{
          width: "100%",
          margin: "2rem 0 2rem 0",
          border: "2px solid #E2E8F0",
          borderRadius: "0.375rem",
          padding: "1rem",
          overflow: "scroll",
        }}
      >
        <div className="assessment-header" style={{ marginBottom: "1.5rem" }}>
          <Flex>
            <div style={{ width: "15%", fontWeight: "bold" }}>Sender Name</div>
            <div style={{ width: "15%", fontWeight: "bold" }}>Message Type</div>
            <div style={{ width: "15%", fontWeight: "bold" }}>Date Sent</div>
            <div style={{ width: "25%", fontWeight: "bold" }}>
              Email Subject
            </div>
            <div style={{ width: "25%", fontWeight: "bold" }}>Template</div>
            <div style={{ width: "5%", fontWeight: "bold" }}></div>
          </Flex>
        </div>
        {communicationHistory.map((message) => {
          return (
            <Flex p="2" key={message.commslogid}>
              <div style={{ width: "15%" }}>
                {message.senderFname} {message.sendersname}
              </div>
              <div style={{ width: "15%" }}>{message.messageType}</div>
              <div style={{ width: "15%" }}>{message.dateon}</div>
              <div style={{ width: "25%" }}>{message.emailSubject}</div>
              <div style={{ width: "25%" }}>{message.templateDescription}</div>
              <div style={{ width: "5%", fontWeight: "bold" }}>
                <Button
                  onClick={() => {
                    handlePreviewClick(message.commslogid);
                  }}
                  colorScheme="orange"
                >
                  View
                </Button>
              </div>
            </Flex>
          );
        })}
      </Box>

      <EmailPreviewModal
        emailBody={selectedEmailBody}
        isOpen={isOpen}
        onClose={onClose}
      />
    </Box>
  );
};

export default Communication;
